import {FormGroup, InputGroup, Intent, Spinner, SpinnerSize} from "@blueprintjs/core";
import * as React from "react";

import {handleChangeString} from "../../../utils/handle-change";
import {ValidationResult} from "../../../utils/validation/validation-result";

interface IValidatedInputTextProps {
    className?: string;
    autoFocus?: boolean;
    value: string;
    validationResult: ValidationResult;
    validationInProgress?: boolean;
    onChangeValue: (value: string) => void;
    label?: string;
    helperText?: React.ReactNode;
    large?: boolean;
    placeholder?: string;
    maxLength?: number;
    style?: React.CSSProperties;
    type?: string;
    rightElement?: React.ReactElement;
    disabled?: boolean;
    helperTextStyle?: React.CSSProperties;
    labelForId?: string;
}

export const ValidatedInputText: React.FC<IValidatedInputTextProps> = (props) => (
    <FormGroup
        className={props.className}
        label={props.label}
        helperText={
            !props.validationResult.isEmpty ? (
                props.validationResult.simpleMessage
            ) : (
                // MEMO: password-reset-page内TODO対応、確認後不要であれば削除
                <span style={props.helperTextStyle}>{props.helperText}</span>
                //   props.helperText
            )
        }
        labelFor={props.labelForId}
    >
        <InputGroup
            id={props.labelForId}
            type={props.type}
            style={props.style}
            value={props.value}
            large={props.large}
            intent={props.validationResult.isEmpty ? Intent.NONE : Intent.DANGER}
            placeholder={props.placeholder}
            onChange={handleChangeString(props.onChangeValue)}
            maxLength={props.maxLength}
            rightElement={
                props.validationInProgress ? (
                    <Spinner size={SpinnerSize.SMALL} />
                ) : (
                    props.rightElement
                )
            }
            autoFocus={props.autoFocus}
            disabled={props.disabled}
        />
    </FormGroup>
);
